import React from 'react';
import fr from 'facet-rest';
import { pick } from 'Helpers/Affordances';
import { FDBodyText } from '@facet-wealth/design';
import DetailsButton from './DetailsButton';

const DetailsButtonPicker = ({ messageResource }) => {
  return pick(messageResource, {
    [fr.relationships.details.name]: <DetailsButton relationship={messageResource.relationship(fr.relationships.details.name)} />,
  }, <FDBodyText value={messageResource.attr('content')} size={'md'} />);
};

export default DetailsButtonPicker;
